import { FC } from 'react';
import { InputMessageProps } from './input-message.types';
import { AnimatePresence, motion } from 'framer-motion';
import * as S from './input-message.styles';

const InputMessge: FC<InputMessageProps> = ({ hint, error }) => (
  <AnimatePresence>
    {(hint || error) && (
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: 'auto', opacity: 1 }}
        exit={{ height: 0, opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        <S.Message $type={error ? 'error' : 'hint'} data-testid="input-message">
          {error || hint}
        </S.Message>
      </motion.div>
    )}
  </AnimatePresence>
);

export default InputMessge;
